/**
 * @file 公开课
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import Review from './components/review'
import Notice from './components/notice'
import { Footer } from '../../components/basic'
import { withTranslation } from 'react-i18next';

import './index.scss'

@withTranslation()

class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    let { t } = this.props;
    return (
      <div>
        <div className="public-class">
          <div style={{ width: '100px', height: "60px" }}></div>
          <div className="banner">
            <div className="popup-layout">
              <div className="popup">
                <div>
                  哈兔免费公开课
                  <br />
                  关于中华传统文化的那些事儿
                </div>
                <div>每月一讲</div>
              </div>
            </div>
          </div>
          <div className="inner-title">{t('publicClass:inner_title')}</div>
          <Notice />
          <Review />
        </div>
        <Footer />
      </div>
    )
  }
}

export default Index
